import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { List } from '../../../../../../core/infrastructure/linq';
import { SelfDiagnosisModel, SelfDiagnosisStepModel } from '../../../../../../store/self-diagnostic/self-diagnosis/model';
import { ServiceModel } from '../../../../../../store/self-diagnostic/service-catalog/model';
import { SelfDiagnosisFacade } from '../../../../../../store/self-diagnostic/self-diagnosis/facade';
import { ServiceCatalogFacade } from '../../../../../../store/self-diagnostic/service-catalog/facade';
import { Observable, Subscription } from 'rxjs';
import { ServiceTypeFacade } from '../../../../../../store/service-type/facade';
import { ServiceTypeModel } from '../../../../../../store/service-type/model';
import DataSource from 'devextreme/data/data_source';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogEditIconComponent } from '../../dialogs/dialog-edit-icon/dialog-edit-icon.component';

@Component({
  selector: 'self-diagnosis-details',
  templateUrl: './self-diagnosis-details.component.html',
  styleUrls: ['./self-diagnosis-details.component.scss'],
  host: {
    class: 'd-block',
  },
  standalone: false,
})
export class SelfDiagnosisDetailsComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  sanitizer = inject(DomSanitizer);
  translate = inject(TranslateService);
  private facade = inject(SelfDiagnosisFacade);
  private serviceCatalogFacade = inject(ServiceCatalogFacade);
  private serviceTypeFacade = inject(ServiceTypeFacade);

  @Input('entityId') public id: number = 0;
  public selfDiagnosis: SelfDiagnosisModel = new SelfDiagnosisModel();
  @Output('onSave') public onSave$ = new EventEmitter<SelfDiagnosisModel>();

  @ViewChild(DialogEditIconComponent) dialogEditIcon: DialogEditIconComponent;

  private services: List<ServiceModel> = new List<ServiceModel>();

  public keyWord: string;
  public keyWords: string[] = [];
  public selectedStep: SelfDiagnosisStepModel;
  private facadeSubsription: Subscription;

  public serviceTypes$: Observable<ServiceTypeModel[]>;

  public searchDataSource: DataSource;
  public selectedMenuItem: ServiceModel;

  public ngOnDestroy() {
    this.facadeSubsription.unsubscribe();
  }

  public ngOnInit(): void {
    this.facadeSubsription = this.facade.selected$.subscribe(async entity => {
      if (entity) {
        this.selfDiagnosis = { ...entity };
        this.selfDiagnosis.selfDiagnosisSteps = new List(entity.selfDiagnosisSteps)
          .Select(s => {
            return { ...s };
          })
          .ToArray();

        this.mapKeyWords();
        this.selectedStep = new List(this.selfDiagnosis.selfDiagnosisSteps).OrderBy(st => st.orderNumber).FirstOrDefault();

        if (this.selfDiagnosis.serviceId) {
          this.selectedMenuItem = this.services.Single(s => s.id == this.selfDiagnosis.serviceId);
          this.searchDataSource.searchValue(this.selectedMenuItem.nameRu);
          await this.searchDataSource.load();
        }
      }
    });

    this.serviceTypes$ = this.serviceTypeFacade.allServiceTypes$;

    if (this.id) {
      this.facade.getById(this.id);
    } else {
      this.facade.setSelected(new SelfDiagnosisModel());
    }

    this.serviceCatalogFacade.filtered$.subscribe(s$ => {
      if (s$) {
        this.services = new List<ServiceModel>(s$);
      }
    });

    this.searchDataSource = new DataSource({
      key: 'ID',
      load: loadOptions => {
        let result = new List<ServiceModel>();

        if (loadOptions.searchValue) {
          let searchString = loadOptions.searchValue.toLowerCase();

          result.AddRange(
            this.services
              .Where(s => s.nameUa.toLowerCase().includes(searchString) || s.nameRu.toLowerCase().includes(searchString))
              .ToArray()
          );

          result.AddRange(
            this.services
              .Where(s => s.keyWords != null)
              .Where(s =>
                new List(
                  s.keyWords
                    .split(',')
                    .map(key => key.trim().toLowerCase())
                    .filter(key => key.includes(searchString))
                ).Any()
              )
              .ToArray()
          );

          result = result.DistinctBy(s => s.id);
        }

        return result.ToArray();
      },
    });
  }

  private mapKeyWords() {
    if (this.selfDiagnosis.keyWords) {
      this.keyWords = this.selfDiagnosis.keyWords.split(',').map(key => key.trim().toLowerCase());
    }
  }

  public addKeyWord() {
    let keyWord = this.keyWord?.toLowerCase().trim();

    if (keyWord && !this.keyWords.includes(keyWord)) {
      this.keyWords.push(keyWord);
    }

    this.keyWord = null;
  }

  public removeKeyWord(keyWord: string) {
    let data = new List(this.keyWords);
    data.Remove(keyWord.toLowerCase().trim());
    this.keyWords = data.ToArray();
  }

  public selectStep(orderNumber: number) {
    this.selectedStep = new List(this.selfDiagnosis.selfDiagnosisSteps).Single(st => st.orderNumber == orderNumber);
  }

  public addStep() {
    let step = new SelfDiagnosisStepModel();
    step.orderNumber = this.selfDiagnosis.selfDiagnosisSteps.length + 1;
    step.selfDiagnosisId = this.selfDiagnosis.id;

    this.selfDiagnosis.selfDiagnosisSteps.push(step);
    this.selectStep(step.orderNumber);
  }

  public save() {
    this.selfDiagnosis.keyWords = this.keyWords.join(', ');
    this.selfDiagnosis.serviceId = this.selectedMenuItem?.id;

    this.onSave$.emit(this.selfDiagnosis);
  }

  public uploadIcon(entity) {
    let selfDiagnosis = <SelfDiagnosisModel>entity;

    this.dialogEditIcon.show().subscribe(result => {
      if (result) {
        this.facade.uploadIcon(selfDiagnosis, result);
      }
    });
  }

  public deleteIcon(entity) {
    let selfDiagnosis = <SelfDiagnosisModel>entity;

    this.facade.deleteIcon(selfDiagnosis);
  }
}
